export default {"src":"/_next/static/media/process_icon_3.d2e241f8.svg","height":69,"width":69};